import { Box, Button, Typography } from '@mui/material';
import Layout from '@src/components/layout/Layout';
import { useMemo, useState } from 'react';
import List from './components/List';
import { useLocation } from 'react-router-dom';
import JobDTO from '@src/adapters/dto/job/JobDTO';
import JobAddEdit from '@src/components/job/JobAddEdit';

function Jobs() {
  const [open, setOpen] = useState(false);
  const [newJob, setNewJob] = useState<JobDTO | undefined>();
  const location = useLocation();

  const productionId = useMemo(() => {
    return location.state.productionId;
  }, [location.state.productionId]);

  const handleNewClick = () => {
    setOpen(true);
  };

  const handleClose = (job: JobDTO | undefined) => {
    if (job) {
      setNewJob(job);
    }
    setOpen(false);
  };

  return (
    <>
      <Layout>
        <Box
          sx={{
            padding: '0 20px 20px 20px',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
          }}>
          <Typography variant="h4">Jobs</Typography>
          <Button
            onClick={handleNewClick}
            color="secondary"
            variant="contained"
            size="medium">
            New Job
          </Button>
        </Box>

        <List productionId={productionId} newJob={newJob} />
      </Layout>
      <JobAddEdit open={open} close={handleClose} productionId={productionId} />
    </>
  );
}

export default Jobs;
